<template>
  <div class="common-layout" >
    <el-container>
      <el-header>
        <div style="display:flex;">
          <el-button type="primary" plain @click="add" style=" position: relative ;left:  0px; margin-right: 10px">生成符合性声明</el-button>
          <el-input v-model="unit" style="width: 20%" maxlength="50" show-word-limit placeholder="输入使用单位" clearable>
          </el-input>
          <el-input v-model="orderNo" style="width: 20%" maxlength="50" show-word-limit placeholder="输入工单号" clearable>
          </el-input>
          <el-button type="primary" plain @click="load" >查询</el-button>
        </div>
<!--        style=" position: relative ;left: -20px"-->
      </el-header>

      <el-main style="margin-top: 0px">
        <el-table
            :data="tableData"
            style="width: 100%;height: 475px"
            border
            :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange"
        >

          <el-table-column  type="selection"  width="55"></el-table-column>
          <el-table-column prop="orderNo"   label="工单号"></el-table-column>
          <el-table-column prop="unit"   label="使用单位"></el-table-column>
          <el-table-column prop="reportResult"   label="报告结论">
            <template v-slot="scope">
              <span v-if="scope.row.reportResult == 0">符合</span>
              <span v-if="scope.row.reportResult == 1">不符合</span>
            </template>
          </el-table-column>
          <el-table-column prop="liftNum"   label="产品编号"></el-table-column>
          <el-table-column prop="loginNum"   label="使用登记证编码"></el-table-column>
          <el-table-column prop="lifeCode"   label="设备代码"></el-table-column>
            <el-table-column prop="unitNum"   label="单位内编码"></el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <div class="demonstration" style="margin: 10px 0">
          <el-pagination v-model:currentPage="currentPage"
                         v-model:page-size="pageSize"
                         :page-sizes="[20, 40,60]"
                         :small="small"
                         :background="background"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total"
                         :prev="prev"
                         :pager="pager"
                         :next="next"
                         :jumper="jumper"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"></el-pagination>
        </div>
        <!--                :disabled="disabled"-->
      </el-footer>
    </el-container>


  </div>
</template>

<script>
import request from "../../util/request";
import { ElLoading } from 'element-plus'
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Statement',
  data() {

    return {
      // search: '',
      currentPage: 1,
      pageSize: 20,
      total: 0,
      small: "small",
      background: "background",
      prev: this.currentPage - 1,
      pager: this.currentPage,
      next: this.currentPage + 1,
      jumper: this.currentPage,
      ticket:[], //未分页的数据
      tableData: [],//渲染到页面上的数据
      unit:'',
      orderNo:'',
      multipleSelection: [],//存储勾选的数据
    }
  },
  created() {
    // this.load();
  },
  methods: {

    //时间格式
    formatDate(value, fmt) {
      if (value == null || value == ''){
        return ""
      }
      let getDate = new Date(value);
      let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        'S': getDate.getMilliseconds()
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return fmt;
    },
    //页面初始化
    load() {
      if(this.unit!==''||this.orderNo!==''){
        // console.log("0000")
      }else {
        this.$message({
          message: "请输入查询条件！",
          type: "warning"
        });
        return false;
      }
      let map ={
        unit:this.unit,
        orderNo:this.orderNo,
      }
      request.post('/ordrecdevice/getordrecdevices',map
        ).then(res => {
        console.log(res);
          if (res.code === '0') {
              this.ticket = res.data;
              this.total = this.ticket.length
              this.getPageInfo()
          }else {
            this.$message({
              message: "无数据！",
              type: "error"
            });
          }

      })
    },
    //保持数据
    add() {
      if(this.multipleSelection===[]||this.multipleSelection.length===0){
        this.$message({
          message: "至少选择一条数据！",
          type: "warning"
        });
        return false;
      }
        // eslint-disable-next-line no-undef
        const loading = ElLoading.service({
            lock: true,
            text: '执行中...',
            background: 'rgba(0, 0, 0, 0.7)',
        });
        setTimeout(() => {
            loading.close();
            return 11;
        }, 2000) ;
        let map ={
            ordRecDeviceList:this.multipleSelection,
            // orderNo:this.orderNo,
        }
      request.post('/ordrecdevice/saveState', map).then(res => {
        console.log(res.code + res.mag + res.data + "save" + res);
          clearTimeout(11);
            if(res.code==='0'){
                window.open(res.data);//打开符合性声明地址路径
            }else {
                this.$message({
                    message: "生成符合性声明失败！",
                    type: "error"
                  });
            }
      })
    },
    handleSelectionChange(val) {
      console.log(val);
        this.multipleSelection=[];
      this.multipleSelection = val;

    },
    //分页三件套
    // 获取当前页的数据信息
    getPageInfo(){
      //清空pageTicket中的数据
      this.tableData=[];
      // 获取当前页的数据
      for(let i=(this.currentPage-1)*this.pageSize;i<this.total;i++){
        //把遍历的数据添加到pageTicket里面
        this.tableData.push(this.ticket[i]);
        //判断是否达到一页的要求
        if(this.tableData.length===this.pageSize) break;
      }
    },
    handleSizeChange(pageSize) {
      //修改当前每页的数据行数
      this.pageSize=pageSize;
      //数据重新分页
      this.getPageInfo();
    },
    handleCurrentChange(pageNum) {
      //修改当前的页码
      this.currentPage=pageNum;
      //数据重新分页
      this.getPageInfo()
    },
    tableRowClassName({rowIndex}) {
      for (var i = 0; i < this.tableData.length; i++) {
        if (rowIndex === i) {
          return 'success-row';
        }

      }
      return '';
    }
  }
}
</script>

<style>

.el-table .warning-row {
  /*--el-table-tr-bg-color: var(--el-color-warning-light-9);*/
  --el-table-tr-bg-color: #e0e0eb
}

.el-table .success-row {
  --el-table-tr-bg-color: var(--el-color-success-light-9);
}
</style>